import axios from 'axios'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { ArrowRight, Download, FileText } from 'react-feather'
import { useSelector } from 'react-redux'
import { Button, Card, CardBody, Spinner } from 'reactstrap'
import moment from 'moment-timezone'
import useIsMobile from '../../../../../hooks/useIsMobile'
import { apiEndpoint } from 'configs'
import { generateDeliveryNote } from '../../dashboardAction'
import { useDispatch } from 'react-redux'

const DownloadDocumentsSection = ({
  transaction,
  isBuyer,
  useTalangin,
  paymentMethod,
  refetch,
  isAdjustment,
  adjustmentitems = [],
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const isMobile = useIsMobile()
  const { token } = useSelector((s) => s.auth)

  const [isLoadingDownload, setIsLoadingDownload] = useState(false)
  const [isLoadingDownloadTransaction, setIsLoadingDownloadTransaction] =
    useState(false)
  const [isLoadingDownloadInvoice, setIsLoadingDownloadInvoice] =
    useState(false)

  const downloadAsPdf = (data, url, type, isGenerated = false) => {
    if (!isGenerated && type === 'DO') {
      setIsLoadingDownload(true)
    } else if (!isGenerated && type === 'INVF') {
      setIsLoadingDownloadInvoice(true)
    }
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      })
      .then((response) => {
        const defName = `TRX/ID/${data.loan ? 'PMG-' : ''}${data.id}`
        var pdfNumber = defName
        if (data.deponumbers && data.deponumbers.length > 1) {
          pdfNumber = data.deponumbers[0].fullNumber
          if (data.loan || data.creditRequested > 0) {
            pdfNumber.replace(type, `${type}/PMG-`)
          }
        }
        var filename = `${pdfNumber.replaceAll('/', '-')}.pdf`
        const disposition = response.headers['content-disposition']
        if (disposition && disposition.indexOf('attachment') !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          var matches = filenameRegex.exec(disposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
        }
        const blobFile = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blobFile)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      })
      .catch(function (error) { })
      .finally(() => {
        setIsLoadingDownload(false)
        setIsLoadingDownloadInvoice(false)
      })
  }

  const downloadTransactionPDF = (data, url) => {
    setIsLoadingDownloadTransaction(true)
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      })
      .then((response) => {
        const defName = `TRX-DETAIL/ID/${data.id}${moment().format('YYYY-MM-DD HH:mm:ss')}`
        var pdfNumber = defName
        var filename = `${pdfNumber.replaceAll('/', '-')}.pdf`
        const disposition = response.headers['content-disposition']
        if (disposition && disposition.indexOf('attachment') !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          var matches = filenameRegex.exec(disposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
        }
        const blobFile = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blobFile)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      })
      .catch(function (error) { })
      .finally(() => setIsLoadingDownloadTransaction(false))
  }

  const handleGenerateDeliveryNote = async (id) => {
    setIsLoadingDownload(true)
    try {
      let res = await dispatch(
        generateDeliveryNote({ escrowpaymentId: id }),
      ).unwrap()
      if (res?.error) {
        enqueueSnackbar(res?.error || 'Surat Jalan gagal diunduh', {
          variant: 'error',
        })
      } else {
        downloadAsPdf(transaction, res?.link, 'DO', true)
      }
    } catch (error) {
      enqueueSnackbar('Surat Jalan gagal diunduh', { variant: 'error' })
    } finally {
      refetch()
      setIsLoadingDownload(false)
    }
  }

  const handleDeliveryNoteClick = async () => {
    const deliveryNoteUrl = transaction?.deliveryNote
    if (deliveryNoteUrl) {
      if (isMobile) {
        downloadAsPdf(transaction, deliveryNoteUrl, 'DO', true)
      } else {
        window.open(
          `/preview-document?url=${encodeURIComponent(deliveryNoteUrl)}&title=${encodeURIComponent('Preview Surat Jalan')}`,
          '_blank',
        )
      }
    } else {
      setIsLoadingDownload(true)
      try {
        let res = await dispatch(
          generateDeliveryNote({
            escrowpaymentId: transaction?.escrowpaymentId,
          }),
        ).unwrap()
        if (res?.error) {
          enqueueSnackbar(res?.error || 'Surat Jalan gagal diunduh', {
            variant: 'error',
          })
        } else {
          refetch()
          if (isMobile) {
            downloadAsPdf(transaction, res?.link, 'DO', true)
          } else {
            window.open(
              `/preview-document?url=${encodeURIComponent(res?.link)}&title=${encodeURIComponent('Preview Surat Jalan')}`,
              '_blank',
            )
          }
        }
      } catch (error) {
        enqueueSnackbar('Surat Jalan gagal diunduh', { variant: 'error' })
      } finally {
        setIsLoadingDownload(false)
      }
    }
  }

  const handlePackingListNoteClick = async () => {
    const packingListUrl = `${apiEndpoint}/api/v1/toko/order/${transaction?.escrowpaymentId}/download-packing-list-note`

    if (isMobile) {
      downloadAsPdf(transaction, packingListUrl, 'PL', true)
    } else {
      window.open(
        `/preview-document?url=${encodeURIComponent(packingListUrl)}&title=${encodeURIComponent('Preview Surat Daftar Paking')}`,
        '_blank',
      )
    }
  }

  const handleReturnLetterClick = async () => {
    const returnLetterUrl = `${apiEndpoint}/api/v1/toko/order/${transaction?.escrowpaymentId}/download-return-letter`

    if (isMobile) {
      downloadAsPdf(transaction, returnLetterUrl, 'SR', true)
    } else {
      window.open(
        `/preview-document?url=${encodeURIComponent(returnLetterUrl)}&title=${encodeURIComponent('Preview Surat Retur')}`,
        '_blank',
      )
    }
  }

  const url = transaction?.urlTransactionDetailPDF
  const isUrlOrderNull = url?.includes('/order/null') ? true : false
  const isCanDownloadTransactionDetailPDF = !isUrlOrderNull

  const txStatus = transaction?.status?.toLowerCase()
  const escrowStatus =
    transaction?.escrowpayment?.status

  const validEscrowStatuses = [
    'ON_GOING',
    'RELEASED_BY_BUYER',
    'RELEASED_BY_SELLER',
    'RELEASED_BY_ADMIN',
  ]

  const isEscrowStatusValid = validEscrowStatuses.includes(escrowStatus)

  const showPackingAndDeliveryNotes = isEscrowStatusValid

  const showReturnLetter =
    isAdjustment &&
    adjustmentitems?.some((item) => item?.editType === 'RETURN') &&
    (txStatus === 'selesai' || txStatus === 'diproses')

  const hasOtherDocuments =
    Array.isArray(transaction?.orderDetail?.files) &&
    transaction.orderDetail.files.length > 0

  // Check if there are any download buttons to show
  const hasDocuments =
    (transaction?.status === 'Selesai' &&
      transaction?.invoice &&
      !(isBuyer && useTalangin)) ||
    showPackingAndDeliveryNotes ||
    isCanDownloadTransactionDetailPDF ||
    showReturnLetter ||
    hasOtherDocuments

  if (!hasDocuments) {
    return null
  }

  return (
    <Card className="border-0 shadow-sm mb-3">
      <CardBody>
        <h6 className="fw-semibold mb-3">Dokumen terkait</h6>
        <div className="d-flex flex-column gap-2">
          {transaction?.status === 'Selesai' &&
            transaction?.invoice &&
            !(isBuyer && useTalangin) && (
              <Button
                outline
                color="primary"
                className="d-flex align-items-center justify-content-between w-100"
                data-testid="detail-transaction-download-invoice"
                onClick={() => {
                  const invoiceUrl = transaction?.escrowpayment?.userpinjamanId
                    ? Number(transaction?.userId) ===
                      Number(transaction?.buyerDetail?.userId)
                      ? transaction?.invoice?.pmToBuyer?.download
                      : transaction?.invoice?.pmToSeller?.download
                    : transaction?.invoice?.download

                  if (isMobile) {
                    downloadAsPdf(transaction, invoiceUrl, 'INVF', true)
                  } else {
                    window.open(
                      `/preview-document?url=${encodeURIComponent(invoiceUrl)}&title=${encodeURIComponent('Preview Invoice')}`,
                      '_blank',
                    )
                  }
                }}
                disabled={isLoadingDownloadInvoice}
              >
                <div className="d-flex align-items-center">
                  {isLoadingDownloadInvoice ? (
                    <Spinner size="sm" className="me-2" />
                  ) : (
                    <Download size={16} className="me-2" />
                  )}
                  <span>Unduh Invoice</span>
                </div>
                {/* <ArrowRight size={16} /> */}
              </Button>
            )}

          {showPackingAndDeliveryNotes && (
            <>
              <Button
                outline
                color="primary"
                className="d-flex align-items-center justify-content-between w-100"
                data-testid="detail-transaction-download-packing-list"
                onClick={handlePackingListNoteClick}
              >
                <div className="d-flex align-items-center">
                  <Download size={16} className="me-2" />
                  <span>Unduh Surat Daftar Paking</span>
                </div>
              </Button>

              <Button
                outline
                color="primary"
                className="d-flex align-items-center justify-content-between w-100"
                data-testid="detail-transaction-download-delivery-note"
                onClick={handleDeliveryNoteClick}
                disabled={isLoadingDownload}
              >
                <div className="d-flex align-items-center">
                  {isLoadingDownload ? (
                    <Spinner size="sm" className="me-2" />
                  ) : (
                    <Download size={16} className="me-2" />
                  )}
                  <span>Unduh Surat Jalan</span>
                </div>
              </Button>
            </>
          )}

          {showReturnLetter && (
            <Button
              outline
              color="primary"
              className="d-flex align-items-center justify-content-between w-100"
              data-testid="detail-transaction-download-return-letter"
              onClick={handleReturnLetterClick}
            >
              <div className="d-flex align-items-center">
                <Download size={16} className="me-2" />
                <span>Unduh Surat Retur</span>
              </div>
            </Button>
          )}

          {isCanDownloadTransactionDetailPDF && (
            <Button
              outline
              color="primary"
              className="d-flex align-items-center justify-content-between w-100"
              data-testid="detail-transaction-download-transaction"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                const transactionUrl = `${transaction?.urlTransactionDetailPDF}&paymentMethod=${paymentMethod}`
                if (isMobile) {
                  downloadTransactionPDF(transaction, transactionUrl)
                } else {
                  window.open(
                    `/preview-document?url=${encodeURIComponent(transactionUrl)}&title=${encodeURIComponent('Preview Detail Transaksi')}`,
                    '_blank',
                  )
                }
              }}
              disabled={isLoadingDownloadTransaction}
            >
              <div className="d-flex align-items-center">
                {isLoadingDownloadTransaction ? (
                  <Spinner size="sm" className="me-2" />
                ) : (
                  <Download size={16} className="me-2" />
                )}
                <span>Unduh Transaksi</span>
              </div>
            </Button>
          )}

          {Array.isArray(transaction?.orderDetail?.files) &&
            transaction.orderDetail.files.map((fileUrl, idx) => {
              if (!fileUrl) return null
              const isPdf = fileUrl.toLowerCase().split('?')[0].endsWith('.pdf')
              const docTitle =
                transaction.orderDetail.files.length > 1
                  ? `Unduh Dokumen Lainnya #${idx + 1}`
                  : 'Unduh Dokumen Lainnya'

              return (
                <Button
                  key={`order-doc-${idx}`}
                  outline
                  color="primary"
                  className="d-flex align-items-center justify-content-between w-100"
                  onClick={() => {
                    if (isMobile) {
                      downloadAsPdf(transaction, fileUrl, 'DOC', true)
                    } else if (isPdf) {
                      window.open(
                        `/preview-document?url=${encodeURIComponent(fileUrl)}&title=${encodeURIComponent('Preview Dokumen')}`,
                        '_blank',
                      )
                    } else {
                      window.open(fileUrl, '_blank')
                    }
                  }}
                >
                  <div className="d-flex align-items-center">
                    <Download size={16} className="me-2" />
                    <span>{docTitle}</span>
                  </div>
                </Button>
              )
            })}
        </div>
      </CardBody>
    </Card>
  )
}

export default DownloadDocumentsSection
